import types from '@/models';
import http from './pushApiConfig';

export default {
  /**
   * Returns the response from the api
   * @param {Array} messages
   * @param {boolean} dryRun
   * @returns {SendPushesResponse} response from the fcm server.
   */
  async sendPushes(messages, dryRun) {
    try {
      const path = dryRun ? `stage/send-push-notifications` : `send-push-notifications`;
      let results = [];
      let messageStatuses = {
        successCount: 0,
        failureCount: 0,
        invalidCount: 0
      }

      for (let i = 0; i < messages.length; i++) {
        let result = http.post(path, [messages[i]]);
        results.push(result);
      }

      const responses = await Promise.all(results);
      responses.forEach((response) => {
         // the api no longer sends pushes, but rather queues them via SQS
         messageStatuses.successCount += response.data.recipientCount;
         messageStatuses.failureCount += response.data.failureCount;
         messageStatuses.invalidCount += response.data.invalidCount;
      });

      console.log(messageStatuses);

      return new types.SendPushesResponse(messageStatuses);
    } catch (e) {
      console.log(e);
    }
    return new types.SendPushesResponse({
      successCount: 0,
      failureCount: 0,
      invalidCount: 0
    });
  },
}
